<template lang="html">
  <div>
    <vs-card v-if="!displayForm" class="cardx">
      <div
        slot="header"
        style="padding: 10px; height: 100%; width: 100%; align-items: center"
      >
        <h3>
          Users ({{ partner_users.pagination.total }} items)
          <div style="float: right">
            <vs-button
              class="mr-3"
              @click="borrarCsv('CSV')"
              color="primary"
              type="filled"
              size="small"
              >Delete csv</vs-button
            >
            <vs-button
              class="mr-3"
              @click="borrarId('ID')"
              color="primary"
              type="filled"
              size="small"
              >Delete</vs-button
            >
            <vs-button
              class="mr-3"
              @click="addNew"
              color="primary"
              type="filled"
              size="small"
              >Add new</vs-button
            >
            <vs-button
              v-if="false"
              class="mr-3"
              @click="$refs.file.click()"
              color="primary"
              type="filled"
              size="small"
              >Import</vs-button
            >
            <vs-button
              class="mr-3"
              @click="downloadAllUsers"
              color="primary"
              type="filled"
              size="small"
              >Export</vs-button
            >
            <vs-button
              class="mr-3 mb-3"
              @click="MassLoad"
              color="primary"
              type="filled"
              size="small"
              >Import</vs-button
            >
            <vs-button
              class="mr-3 mb-3"
              @click="customFieldsForm"
              color="primary"
              type="filled"
              size="small"
              >Custom Fields</vs-button
            >
            <vs-dropdown
              class="vs-component vs-button vs-button-primary vs-button-filled small"
            >
              <div style="color: white">Send QR codes</div>
              <vs-dropdown-menu style="width: 200px">
                <vs-dropdown-item class="mt-1 mb-1" @click="promptQr('ONLINE')">
                  Online users
                </vs-dropdown-item>
                <vs-dropdown-item
                  class="mt-1 mb-1"
                  @click="promptQr('OFFLINE')"
                >
                  Offline users
                </vs-dropdown-item>
                <vs-dropdown-item class="mt-1 mb-1" @click="promptQr('IDS')">
                  Selected users
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </h3>
      </div>

      <div>
        <input
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          ref="file"
          v-on:change="handleFilesUpload"
          type="file"
          style="height: 0px; visibility: hidden; position: absolute"
        />
        <vs-table
          stripe
          search
          :sst="true"
          @search="handleSearch"
          :data="partner_users.partner_user"
        >
          <template slot="header">
            <vs-row style="margin-bottom: 20px">
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                <div
                  style="
                    width: 300px;
                    display: inline-block;
                    margin-right: 10px;
                  "
                >
                  <label class="vs-input--label">Zone</label>
                  <v-select
                    @input="filters.page = 1"
                    v-model="filters.zone_id"
                    :clearable="false"
                    :options="zones"
                    :reduce="(el) => el.id"
                    label="name"
                  />
                </div>
                <div
                  style="
                    width: 200px;
                    display: inline-block;
                    margin-right: 10px;
                  "
                >
                  <label class="vs-input--label">User type</label>
                  <v-select
                    @input="filters.page = 1"
                    v-model="filters.type"
                    :clearable="false"
                    :options="userTypes"
                    :reduce="(el) => el.value"
                    label="label"
                  />
                </div>
                <div
                  style="
                    width: 200px;
                    display: inline-block;
                    margin-right: 10px;
                  "
                >
                  <label class="vs-input--label">Status</label>
                  <v-select
                    @input="filters.page = 1"
                    v-model="filters.is_active"
                    :clearable="false"
                    :options="userStatus"
                    :reduce="(el) => el.value"
                    label="label"
                  />
                </div>

                <div
                  style="
                    width: 200px;
                    display: inline-block;
                    margin-right: 10px;
                  "
                >
                  <label class="vs-input--label">Code</label>
                  <v-select
                    @input="filters.page = 1"
                    v-model="filters.type_code"
                    :clearable="false"
                    :options="typeCode"
                    :reduce="(el) => el.value"
                    label="label"
                  />
                </div>
              </vs-col>
            </vs-row>

            <vs-col vs-lg="4" vs-sm="4" vs-xs="12">
              <vs-row>
                <vs-dropdown
                  class="mr-2"
                  vs-custom-content
                  vs-trigger-click
                  vs-drop-right
                  :vs-dropdown-visible="true"
                  style="float: right"
                >
                  <vs-chip transparent color="primary" style="min-width: 130px">
                    <b>From</b>: {{ from_date }}
                  </vs-chip>
                  <vs-dropdown-menu class="loginx">
                    <datepicker
                      @input="updateDateQuery"
                      calendar-class="border-none"
                      :inline="true"
                      v-model="dates.from_date"
                      format="yyyy-MM-dd"
                    ></datepicker>
                  </vs-dropdown-menu>
                </vs-dropdown>

                <vs-dropdown
                  class="mr-2"
                  vs-custom-content
                  vs-trigger-click
                  vs-drop-right
                  :vs-dropdown-visible="true"
                  style="float: right"
                >
                  <vs-chip transparent color="primary" style="min-width: 130px">
                    <b>To</b>: {{ to_date }}
                  </vs-chip>
                  <vs-dropdown-menu class="loginx">
                    <datepicker
                      @input="updateDateQuery"
                      calendar-class="border-none"
                      :inline="true"
                      v-model="dates.to_date"
                      format="yyyy-MM-dd"
                    ></datepicker>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </vs-row>
            </vs-col>
          </template>

          <template slot="thead">
            <vs-th>
              <vs-checkbox size="small" v-model="selectAll"></vs-checkbox>
            </vs-th>
            <vs-th sort-key="eco"> Name </vs-th>
            <vs-th sort-key="Phone"> Phone </vs-th>
            <vs-th sort-key="Email"> Email </vs-th>
            <vs-th> Code </vs-th>
            <vs-th> Created </vs-th>
            <vs-th> Code </vs-th>
            <vs-th> Edit </vs-th>
            <vs-th> Action </vs-th>
            <vs-th> Status </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr :data="item.id" :key="item.id" v-for="(item, index) in data">
              <vs-td>
                <vs-checkbox
                  size="small"
                  v-model="selected"
                  :vs-value="item.id"
                ></vs-checkbox>
              </vs-td>
              <vs-td>
                {{ item.name }}
              </vs-td>
              <vs-td>
                {{ item.phone }}
              </vs-td>
              <vs-td>
                {{ item.email }}
              </vs-td>
              <vs-td>
                {{ item.unlock_code }}
              </vs-td>
              <vs-td>
                {{ item.created_at }}
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="DownloadIcon"
                  @click="displayQrCode(item)"
                  class="cursor-pointer navbar-fuzzy-search mr-4"
                />
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  @click="editUser(item)"
                  class="cursor-pointer navbar-fuzzy-search mr-4"
                />
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="Trash2Icon"
                  @click="deleteUser(item.id)"
                  class="cursor-pointer navbar-fuzzy-search mr-4"
                />
              </vs-td>
              <vs-td>
                <vs-button
                  class="ui button big"
                  :color="item.is_active ? 'primary' : 'danger'"
                  @click="userActive(item)"
                  type="filled"
                  size="small"
                  >{{ item.is_active ? "ON" : "OFF" }}</vs-button
                >
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <div class="mt-3 mb-3">
          <span style="float: left">
            <vs-select
              @input="filters.page = 1"
              class=""
              label=""
              v-model="filters.limit"
              width="100px"
              size="small"
            >
              <vs-select-item
                :key="'lim-' + index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in limitOptions"
              />
            </vs-select>
          </span>
          <pagination
            :last-page="partner_users.pagination.pages"
            v-model="filters.page"
          />
        </div>

        <vs-popup
          @close="display_qr = false"
          class="crop-modal"
          title="Code"
          :active.sync="display_qr"
        >
          <div style="text-align: center" v-if="!displayInputCode">
            <div id="qrcode">
              <vue-qr
                :text="user ? user.qr.code : ''"
                :margin="20"
                :size="420"
                :autoColor="true"
                :logoMargin="0"
                :logoCornerRadius="0"
                :dotScale="1"
                :callback="onQrCallback"
                qid="testid"
              ></vue-qr>

              <div v-if="user" style="padding-bottom: 10px">
                <div class="mb-2">
                  <h4>{{ user.name }}</h4>
                </div>
                <div class="mb-2">
                  <h4>Code: {{ user.unlock_code }}</h4>
                </div>
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <vs-button
                class="mr-3"
                @click="downloadQR"
                color="danger"
                type="filled"
                >Download</vs-button
              >
              <div
                style="width: 300px; display: inline-block; margin-right: 10px"
              >
                <v-select
                  @input="verfiltro"
                  v-model="code_type"
                  :clearable="false"
                  :options="codeType_array.code_type"
                />
              </div>
            </div>
          </div>

          <div style="text-align: center" v-if="displayInputCode">
            <div id="qrcode">
              <barcode
                v-bind:value="user ? user.qr.code : ''"
                font-options="bold"
                :format="
                  code_type
                    ? code_type === 'CODE128'
                      ? 'CODE128'
                      : 'CODE39'
                    : ''
                "
                width="1"
              >
                Can't generate the barcode
              </barcode>

              <div v-if="user" style="padding-bottom: 10px">
                <div class="mb-2">
                  <h4>{{ user.name }}</h4>
                </div>
                <div class="mb-2">
                  <h4>Code: {{ user.unlock_code }}</h4>
                </div>
              </div>
            </div>
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: center;
              "
            >
              <vs-button
                class="mr-3"
                @click="downloadQR"
                color="danger"
                type="filled"
                >Download</vs-button
              >
              <div
                style="width: 300px; display: inline-block; margin-right: 10px"
              >
                <v-select
                  @input="verfiltro"
                  v-model="code_type"
                  :clearable="false"
                  :options="codeType_array.code_type"
                />
              </div>
            </div>
          </div>
        </vs-popup>

        <vs-popup
          @close="display_barcode = false"
          class="crop-modal"
          title="Barcode"
          :active.sync="display_barcode"
        >
          <div style="text-align: center">
            <div id="barcode">
              <barcode
                v-bind:value="user ? 'test12345' : ''"
                font-options="bold"
                :format="
                  user ? (user.qrType === 'CODE128' ? 'CODE128' : 'CODE39') : ''
                "
                width="1"
              >
                Can't generate the barcode
              </barcode>

              <div v-if="user" style="padding-bottom: 10px">
                <div class="mb-2">
                  <h4>{{ user.name }}</h4>
                </div>
                <div class="mb-2">
                  <h4>Code: {{ user.unlock_code }}</h4>
                </div>
              </div>
            </div>
            <div>
              <vs-button
                class="mr-3"
                @click="downloadBarcode"
                color="danger"
                type="filled"
                >Download</vs-button
              >
            </div>
          </div>
        </vs-popup>

        <vs-popup
          @close="displayUserForm = false"
          class="crop-modal"
          :title="form.id ? 'Edit user' : 'New user'"
          :active.sync="displayUserForm"
        >
          <div>
            <vs-row>
              <vs-col
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                style="padding: 10px 10px 0px 10px"
              >
                <vs-input
                  v-model="form.name"
                  type="text"
                  name="name"
                  :danger="errors.has('name')"
                  :danger-text="errors.first('name')"
                  val-icon-danger="close"
                  label="Name"
                  placeholder=""
                  style="width: 100%"
                />
              </vs-col>

              <vs-col
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                style="padding: 10px 10px 0px 10px"
              >
                <vs-input
                  v-model="form.email"
                  name="email"
                  type="email"
                  v-validate="'email'"
                  :danger="errors.has('email')"
                  :danger-text="errors.first('email')"
                  val-icon-danger="close"
                  label="Email"
                  placeholder=""
                  style="width: 100%"
                />
              </vs-col>

              <vs-col
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                style="padding: 10px 10px 0px 10px"
              >
                <vs-input
                  v-model="form.phone"
                  name="phone"
                  type="number"
                  v-validate="'numeric|digits:10'"
                  :danger="errors.has('phone')"
                  :danger-text="errors.first('phone')"
                  val-icon-danger="close"
                  label="Phone"
                  placeholder=""
                  style="width: 100%"
                />
              </vs-col>

              <vs-col
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                style="padding: 10px 10px 10px 10px"
              >
                <vs-input
                  v-model="form.unlock_code"
                  name="unlock_code"
                  type="text"
                  v-validate="'required'"
                  :danger="errors.has('unlock_code')"
                  :danger-text="
                    errors.has('unlock_code')
                      ? errors.first('unlock_code')
                      : null
                  "
                  val-icon-danger="close"
                  :label="'Unlock code' + (true ? ' (Requerido)' : '')"
                  placeholder=""
                  style="width: 100%"
                  :disabled="form.id ? true : false"
                />
              </vs-col>

              <vs-col
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                style="padding: 0px 10px 0px 10px"
              >
                <vs-input
                  v-model="form.code"
                  name="code"
                  type="text"
                  v-validate="'required'"
                  :danger="errors.has('code')"
                  :danger-text="
                    errors.has('code') ? errors.first('code') : null
                  "
                  val-icon-danger="close"
                  :label="'Code' + (true ? ' (Requerido)' : '')"
                  placeholder=""
                  style="width: 100%"
                  :disabled="form.id ? true : false"
                />
              </vs-col>

              <vs-col
                v-for="(field, index) in customFields"
                :key="index"
                vs-lg="6"
                vs-sm="6"
                vs-xs="12"
                style="padding: 0px 10px 0px 10px"
              >
                <div class="custom-field-container" style="min-height: 70px">
                  <vs-input
                    v-model="field.value"
                    :type="field.type === 'number' ? 'number' : 'text'"
                    :name="`personalizado '${field.label}'`"
                    :label="
                      (
                        field.label + (field.required ? ' (Requerido)' : '')
                      ).replace('*', '')
                    "
                    v-validate="{ required: field.required }"
                    @input="
                      $validator.validate(`personalizado '${field.label}'`)
                    "
                    :danger="errors.has(`personalizado '${field.label}'`)"
                    :danger-text="
                      errors.first(`personalizado '${field.label}'`)
                    "
                    val-icon-danger="close"
                    style="width: 100%"
                  />
                </div>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
                <vs-button
                  class="mr-3"
                  @click="displayUserForm = false"
                  color="danger"
                  type="filled"
                  >Cancel</vs-button
                >
                <vs-button
                  class="mr-3"
                  @click="saveUser"
                  color="primary"
                  type="filled"
                >
                  Save
                </vs-button>
              </vs-col>
            </vs-row>
          </div>
        </vs-popup>

        <vs-prompt
          title="QR codes"
          @cancel="
            selected = [];
            qrForm = {};
          "
          @accept="sendQr"
          @close="closeQrPrompt"
          :active.sync="showQrForm"
        >
          <div class="con-exemple-prompt">
            <form @submit.prevent="" data-vv-scope="qr">
              <vs-input
                style="width: 100%"
                type="email"
                placeholder="example@mail.com"
                v-model="qrForm.email"
                name="email"
                label="Enter email addreess"
                v-validate="'required|email'"
                :danger="errors.has('qr.email')"
                :danger-text="
                  errors.has('qr.email') ? errors.first('qr.email') : null
                "
                val-icon-danger="close"
              />

              <vs-select
                class="mt-2"
                label="Size"
                name="size"
                v-validate="'required'"
                v-model="qrForm.size"
                :danger="errors.has('qr.size')"
                :danger-text="
                  errors.has('qr.size') ? errors.first('qr.size') : null
                "
                val-icon-danger="close"
                style="width: 100%"
                size="small"
              >
                <vs-select-item
                  :key="'lim-' + index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in qrSizes"
                />
              </vs-select>
              <vs-checkbox class="mt-4" v-model="qrForm.display_name"
                >Display name</vs-checkbox
              >
            </form>
          </div>
        </vs-prompt>
      </div>
    </vs-card>

    <vs-card
      v-if="displayForm"
      class="cardx card-100-h"
      v-bind:style="{ height: windowHeight - 155 + 'px' }"
    >
      <div>
        <vs-row>
          <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
            <div>
              <h3 style="margin-bottom: 10px">{{ formTitle }}</h3>
              <span style="cursor: pointer" @click="downloadTemplate"
                >Download template</span
              >

              <div>
                <vs-row>
                  <vs-col
                    vs-lg="12"
                    vs-sm="12"
                    vs-xs="12"
                    style="padding: 10px"
                  >
                    <label class="vs-input--label">Zone</label>
                    <v-select
                      @input="filters.page = 1"
                      v-model="filters.zone_id"
                      :clearable="false"
                      :options="zones"
                      :reduce="(el) => el.id"
                      label="name"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-lg="6" vs-sm="6" vs-xs="12" style="padding: 10px">
                    <input
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv"
                      ref="fileCsv"
                      type="file"
                      @click="uploadFile"
                    />
                  </vs-col>
                </vs-row>
              </div>

              <div class="mb-4">
                <vs-button
                  class="mr-3"
                  @click="Masssave"
                  color="danger"
                  type="filled"
                  :disabled="showError"
                  >Guardar</vs-button
                >
                <vs-button @click="cancel" color="primary" type="filled"
                  >Cancelar</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-card>

    <CustomFieldsForm
      :showModal="displayCustomFields"
      @close="displayCustomFields = false"
    />

    <vs-popup title="Progress">
      <vs-row style="margin-bottom: 20px">
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-slider disabled="true" v-model="progress" :min="0" :max="100" />
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      @close="showProgress = false"
      button-close-hidden
      class="crop-modal"
      title="Import Progress"
      :active.sync="showProgress"
    >
      <vs-row>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          Progress of import:
        </vs-col>
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12" style="padding: 10px">
          <div
            :style="{
              background: 'red',
              height: '15px',
              width: progress + '%',
            }"
          ></div>
          <div
            style="
              fontsize: 1rem;
              fontweight: bold;
              color: red;
              textalign: center;
            "
          >
            {{ progress }}%
          </div>
        </vs-col>
        <vs-col
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
          style="padding: 10px; textalign: center"
          v-if="progress === 100"
        >
          <vs-button
            @click="showProgress = false"
            color="primary"
            type="filled"
            size="small"
            >Ok</vs-button
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Errores al cargar el archivo"
      :active.sync="errorActive"
    >
      <div style="max-height: 500px; overflow-y: auto">
        <div v-html="tablaErroresHtml"></div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import VueQr from "vue-qr";
import VueBarcode from "vue-barcode";
import html2canvas from "html2canvas";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
const FileDownload = require("js-file-download");
import limitOptions from "../../../constants/limit";
import { qrSizes } from "../../../constants/utils";
import CustomFieldsForm from "./CustomFields/PartnerCustomFields/CustomFieldsForm";
import Values from "./CustomFields/NewUser/Values";
import Errors from "./CustomFields/BatchUpload/Errors";

export default {
  name: "Users",
  components: {
    Datepicker,
    VueQr,
    CustomFieldsForm,
    UserCustomFields: Values,
    ErrorsCustomFields: Errors,
    barcode: VueBarcode,
  },
  mounted() {
    this.getCustomFields().then((customFields) => {
      this.customFields = customFields;
    });
  },
  data() {
    return {
      page: 0,
      search: null,
      code_type: "Code Type",
      codeType_array: {
        code_type: ["QR", "BARCODE_128", "BARCODE_39"],
      },
      customer: null,
      filters: {},
      qr_code: null,
      qr_value: "",
      display_qr: false,
      display_barcode: false,
      user: null,
      displayUserForm: false,
      displayForm: false,
      displayInputCode: false,
      displayCustomFields: false,
      form: {},
      customFields: [],
      windowHeight: 0,
      barcodeValue: "cus_0fftm8t9n5p5ii819jng",
      showError: false,
      showProgress: false,
      progress: 0,
      dates: {
        page: 0,
        to_date: moment().subtract(1, "days").toDate(),
        from_date: moment().toDate(),
      },
      partner_users: {
        partner_user: [],
        pagination: {
          page: 1,
          limit: 10,
          total: 0,
          pages: 0,
          prev: null,
          next: null,
        },
      },
      userTypes: [
        { label: "All", value: null },
        { label: "Online", value: "online" },
        { label: "Offline", value: "offline" },
      ],
      userStatus: [
        { label: "All", value: null },
        { label: "Active", value: true },
        { label: "Desactive", value: false },
      ],
      typeCode: [
        { label: "All", value: null },
        { label: "QR", value: "QR" },
        { label: "BARCODE_128", value: "BARCODE_128" },
        { label: "BARCODE_39", value: "BARCODE_39" },
      ],
      selected: [],
      qrForm: {
        type: null,
      },
      showQrForm: false,
      limitOptions,
      qrSizes,
      errorActive: false,
      tablaErroresHtml: "",
    };
  },
  computed: {
    ...mapState("partners", ["currentPage"]),
    ...mapState("users", ["currentUser"]),
    ...mapState("zones", ["zones"]),
    ...mapGetters("customFields", ["payloadUserCustomFields"]),
    to_date() {
      return moment(this.dates.to_date).format("YYYY-MM-DD");
    },
    from_date() {
      return moment(this.dates.from_date).format("YYYY-MM-DD");
    },
    hasCustomFields() {
      return this.$store.state.customFields.fields.length > 0;
    },
    selectAll: {
      get() {
        let ids = this.partner_users.partner_user.map((item) => item.id);
        let inter = _.intersection(this.selected, ids);
        return inter.length === this.partner_users.partner_user.length;
      },
      set(value) {
        let selected = _.cloneDeep(this.selected);
        let ids = this.partner_users.partner_user.map((item) => item.id);
        if (value) {
          selected = _.union(selected, ids);
        } else {
          selected = _.pullAll(selected, ids);
        }
        this.selected = selected;
      },
    },
    isSaveDisabled() {
      return (
        !this.form.unlock_code ||
        !this.form.code ||
        this.customFields.some((field) => field.required && !field.value)
      );
    },
  },
  watch: {
    filters: {
      deep: true,
      handler(newVal, oldVal) {
        this.setRouteQuery();
        this.doSearch();
      },
    },
  },
  created() {
    this.filters = {
      limit: "20",
      ...this.$route.query,
      page: this.$route.query.page ? Number(this.$route.query.page) : 1,
      zone_id: this.$route.query.zone_id
        ? this.$route.query.zone_id
        : this.zones.length > 0
        ? this.zones[0].id
        : null,
    };
    this.doSearch = _.debounce(this.getItems, 300);
  },
  methods: {
    ...mapGetters("users", ["userCan"]),
    ...mapActions("partners", [
      "partnerCodeConfig",
      "fetchPartnerUsers",
      "downloadQrCodes",
      "storePartnerUser",
      "deletePartnerUser",
      "getPartnerUser",
      "updatePartnerUser",
      "getPartnerZones",
      "downloadPartnerUsers",
      "MassLoadUsers",
      "CheckUsersProgress",
      "UsersActivate",
    ]),
    ...mapMutations("partners", ["SET_PARTNER_USERS"]),
    ...mapActions("customFields", ["getCustomFields", "batchUploadTemplate"]),
    ...mapMutations("customFields", ["CLEAR_USER_CUSTOM_FIELDS_VALUES"]),
    validateField(fieldId) {
      this.$validator.validate(`custom-field-${fieldId}`);
    },
    setRouteQuery() {
      let query = { ...this.filters, page: `${this.filters.page}` };
      if (!_.isEqual(query, this.$route.query)) {
        try {
          this.$router.push({ query });
        } catch (error) {}
      }
    },
    openConfirm() {
      const errores = this.convertirErrores(this.errors_array);

      let tablaErrores = `
    <table style="width:100%; border-collapse: collapse;">
      <thead>
        <tr style="border-bottom: 1px solid black;">
          <th style="text-align:left; padding: 8px;">Fila</th>
          <th style="text-align:left; padding: 8px;">Columna</th>
          <th style="text-align:left; padding: 8px;">Mensaje</th>
        </tr>
      </thead>
      <tbody>
  `;

      errores.forEach((error) => {
        tablaErrores += `
      <tr style="border-bottom: 1px solid black;">
        <td style="padding: 8px;">${error.fila}</td>
        <td style="padding: 8px;">${error.columna}</td>
        <td style="padding: 8px;">${error.mensaje}</td>
      </tr>
    `;
      });

      tablaErrores += `</tbody></table>`;

      this.tablaErroresHtml = tablaErrores;

      this.errorActive = true;
    },
    convertirErrores(array) {
      let errorData = [];

      array.forEach((item) => {
        const fila = Object.keys(item)[0];
        const columnasErrores = Object.values(item)[0];

        for (const columna in columnasErrores) {
          const mensajesErrores = columnasErrores[columna];

          mensajesErrores.forEach((mensaje) => {
            errorData.push({
              fila,
              columna,
              mensaje,
            });
          });
        }
      });

      return errorData;
    },
    getErrorMessages(error) {
      const errorMsg = new Map([
        ["exists in DB", "ya existe en la base de datos"],
        ["empty", "no puede estar vacío"],
        ["invalid", "no es válido"],
      ]);
      if (error.includes("exists in DB")) {
        return errorMsg.get("exists in DB");
      }

      return "tiene un error";
    },
    getItems(search) {
      if (!this.userCan("capacity_control_user.read")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.loading({ type: "point" });
      let payload = _.cloneDeep(this.filters);
      payload.partner_id = this.currentUser.partner;

      if (payload.is_active === 0) {
        delete payload.is_active;
      }

      this.fetchPartnerUsers(payload)
        .then((data) => {
          this.partner_users = data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });

      this.partnerCodeConfig()
        .then((data) => {
          this.codeType_array.code_type = data.config.code_type;
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
        });
    },
    handleSearch(searching) {
      this.filters = { ...this.filters, page: 1, search: searching };
    },
    handleSelected(tr) {
      //this.$router.push({name:'customers.detail', params: {id: tr.id}});
      /*
      this.customer = tr;
      this.filters =  {
        customer_id : this.customer.id,
      };
      //this.filters = [{ field: 'customer.id', op: '=', value: this.customer.id}]

       */
    },
    displayQrCode(user) {
      this.user = {
        ...user,
        qrType: this.code_type,
      };
      console.log("users", this.user);
      this.display_qr = true;
    },
    onQrCallback(imageUri) {
      this.qr_code = imageUri;
    },
    downloadQR() {
      html2canvas(document.getElementById("qrcode"), {
        scrollY: 0,
        scrollX: 0,
      }).then((canvas) => {
        let linkSource = canvas.toDataURL("image/png");
        linkSource = linkSource.replace(
          /^data:image\/png/,
          "data:application/octet-stream"
        );
        //const linkSource = this.qr_code;
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = "_self";
        downloadLink.download = `QRcode_${this.user.id}.png`;
        downloadLink.click();
      });
    },

    downloadBarcode() {
      html2canvas(document.getElementById("barcode"), {
        scrollY: 0,
        scrollX: 0,
      }).then((canvas) => {
        //document.body.appendChild(canvas);
        let linkSource = canvas.toDataURL("image/png");
        linkSource = linkSource.replace(
          /^data:image\/png/,
          "data:application/octet-stream"
        );
        //const linkSource = this.qr_code;
        const downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);

        downloadLink.href = linkSource;
        downloadLink.target = "_self";
        downloadLink.download = `QRcode_${this.user.id}.png`;
        downloadLink.click();
      });
    },
    downloadAllUsers() {
      this.$vs.loading({ type: "point" });
      // this.fetchPartnerUsers({
      //   ...this.filters,
      //   partner_id: this.currentUser.partner,
      //   limit:100000
      // })
      //   .then(response=>{
      //     this.$vs.loading.close();
      //     let jsonArr = response.partner_user.map(item=>({
      //       name: item.name,
      //       email: item.email,
      //       phone: item.phone,
      //       code: item.unlock_code,
      //     }));

      //     let data = XLSX.utils.json_to_sheet(jsonArr);

      //     const workbook = XLSX.utils.book_new();
      //     const filename = 'users';
      //     XLSX.utils.book_append_sheet(workbook, data, filename);
      //     XLSX.writeFile(workbook, `users-${moment().format()}.xls`);

      //   })
      //   .catch(error =>{
      //     this.$vs.loading.close();
      //   })
      let filters1 = {
        zone_id: this.filters.zone_id,
        type: this.filters.type,
        page: this.filters.page,
        is_active: this.filters.is_active,
        from_date: this.filters.from_date,
        to_date: this.filters.to_date,
      };
      if (filters1.is_active === 0) {
        delete filters1.is_active;
      }

      this.downloadPartnerUsers(filters1)
        .then((response) => {
          this.$vs.loading.close();
          FileDownload(response, `users-${moment().format()}.csv`);
        })
        .catch((error) => {
          console.log(error, "error al descargar");
          this.$vs.loading.close();
        });
    },

    ///////////////

    MassLoad() {
      console.log("mass load");
      this.formTitle = "Mass Charge";
      this.displayForm = true;
    },
    uploadFile() {
      console.log("uploadFile");
      this.showError = false;
    },
    customFieldsForm() {
      this.displayCustomFields = true;
    },
    Masssave() {
      if (this.filters.zone_id) {
        this.handleFilesUploadCSV();
      } else {
        alert("Select a Zone.");
      }
    },
    cancel() {
      this.displayForm = false;
    },
    handleFilesUploadCSV() {
      this.submitFileCsv(this.$refs.fileCsv.files[0]);
    },
    submitFileCsv(file) {
      this.$vs.loading({ type: "point" });
      let formDataCsv = new FormData();
      formDataCsv.append("partner_id", this.currentUser.partner);
      formDataCsv.append("zone_id", this.filters.zone_id);
      formDataCsv.append("file", file);
      console.log("FORM", formDataCsv);
      this.MassLoadUsers(formDataCsv)
        .then((data) => {
          if (data.id) {
            this.checkprogress(data.id);
            this.$vs.loading.close();
          }
        })
        .catch((error) => {
          console.log("error1:", error);
          if (error.status === 400) {
            this.errors_array = null;
            this.errors_array = error.data.errors;
            this.openConfirm();
            this.errors_detail = error.data.detail;
            this.showError = true;
          }
          this.$vs.loading.close();
        });
    },
    checkprogress(data_id) {
      let payload = { task_id: data_id };
      this.CheckUsersProgress(payload)
        .then((data) => {
          this.progress = 0;
          console.log("CheckUsersProgress data", data);
          this.showProgress = true;
          if (data.status === "FAILURE") {
            this.errors_array = null;
            this.errors_array = data.errors;
            this.showError = true;
            this.showProgress = false;
            this.$vs.loading.close();

            setTimeout(() => {}, 500);
            return false;
          }
          if (data.progress != 100) {
            this.progress = data.progress;
            setTimeout(() => {
              this.checkprogress(data_id);
            }, 1000);
          } else {
            this.progress = 100;
            this.displayForm = false;
            setTimeout(() => {
              this.getItems();
            }, 500);
          }
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.log("CheckTripsProgress error:", error);
          alert("Error on Import.");
          this.progress = 0;
          this.showProgress = false;
          this.$vs.loading.close();
        });
    },
    userActive(item) {
      // this.isActive = this.isActive ? false : true;
      this.UsersActivate(item)
        .then((data) => {
          console.log("UsersActivate:", data);
          this.getItems();
        })
        .catch((error) => {
          console.log("UsersActivate error:", error);
        });
    },
    promptQr(type) {
      let form = {
        type: type,
        zone_id: this.filters.zone_id,
        size: "610X700",
        display_name: true,
        is_active: this.filters.is_active,
        from_date: this.filters.from_date,
        to_date: this.filters.to_date,
      };
      if (type === "IDS") {
        var temparray = [];
        for (var i = 0; i < this.selected.length; i++) {
          if (this.selected[i].id) {
          } else {
            temparray.push(this.selected[i]);
          }
        }
        form.ids = temparray;
      }
      this.qrForm = _.cloneDeep(form);
      this.showQrForm = true;

      console.log("qrForm:", this.qrForm);
    },
    closeQrPrompt() {},
    updateDateQuery() {
      console.log("update query", this.dates.to);
      //date.since

      this.page = 1;
      this.filters = {
        ...this.filters,
        page: 1,
        from_date: this.from_date,
        to_date: this.to_date,
      };
    },
    sendQr() {
      this.$validator.validateAll("qr").then((result) => {
        this.showQrForm = !result;
        if (result) {
          this.downloadQrCodes(_.cloneDeep(this.qrForm))
            .then((response) => {
              this.qrForm = {};
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "We will send you an email with QR codes",
              });
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Oops, something went wrong! Try later",
              });
            });
        }
      });
    },

    async addNew() {
      if (!this.userCan("capacity_control_user.create")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      try {
        const customFields = await this.getCustomFields();
        this.customFields = customFields.map((field) => ({
          ...field,
          value: "",
        }));

        this.form = {};
        this.displayUserForm = true;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "No se pudieron obtener los campos personalizados.",
        });
      }
    },
    validUserCustomFields() {
      return this.$store.state.customFields.fields
        .filter((f) => f.required)
        .every((f) => f.value !== "");
    },
    borrarCsv(id) {
      console.log("entro", this.selected);
      this.$router.push({ name: "partner.users.delete", params: { id } });
    },
    borrarId(id) {
      if (this.selected.length != 0) {
        localStorage.setItem("selectedUsers", JSON.stringify(this.selected));
        this.$router.push({ name: "partner.users.delete", params: { id } });
      } else {
        this.$vs.dialog({
          color: "danger",
          title: "Error",
          text: "You must select at least one user",
        });
      }
    },
    async saveUser() {
      this.$vs.loading({ type: "point" });

      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "Completa todos los campos requeridos antes de continuar.",
        });
        this.$vs.loading.close();
        return;
      }

      const customFieldsData = this.customFields.map((field) => field.value);

      const userData = {
        ...this.form,
        custom_fields: customFieldsData,
        zone_id: this.filters.zone_id,
      };

      try {
        if (this.form.id) {
          await this.updatePartnerUser(userData);
        } else {
          await this.storePartnerUser(userData);
        }
        this.displayUserForm = false;
        this.getItems();
      } catch (error) {
        let errorMessage = "Ocurrió un error al guardar el usuario.";

        if (error.data && error.data.errors) {
          const errorDetails = Object.values(error.data.errors)
            .flat()
            .join(" | ");

          errorMessage = errorDetails;
        } else if (error.data && error.data.detail) {
          errorMessage = error.data.detail;
        }

        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    handleFilesUpload() {
      this.submitFile(this.$refs.file.files[0]);
    },
    submitFile(file) {
      let formData = new FormData();
      formData.append("file", file);
      axios
        .post("/api/v1/employees/import", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {})
        .catch((error) => {});
    },

    setErrors(errors) {
      this.errors.clear();
      for (let key in errors) {
        if (Array.isArray(errors[key])) {
          this.errors.add({
            field: key,
            msg: errors[key][0],
          });
        }
      }
    },

    async editUser(user) {
      this.$vs.loading({ type: "point" });

      try {
        const customFields = await this.getCustomFields();
        this.customFields = customFields.map((field) => ({
          ...field,
          value: "",
        }));

        const data = await this.getPartnerUser(user.id);

        this.form = {
          id: data.id,
          name: data.name,
          email: data.email,
          phone: data.phone,
          unlock_code: data.unlock_code,
          code: data.code,
        };

        this.customFields = this.customFields.map((field, index) => {
          return {
            ...field,
            value: data.custom_fields[index] || "",
          };
        });

        this.displayUserForm = true;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Error",
          text: "No se pudo cargar la información del usuario.",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    deleteUser(id) {
      if (!this.userCan("capacity_control_user.delete")) {
        this.$vs.notify({
          color: "danger",
          title: `Error`,
          text: "You need permission to perform this action",
        });
        return;
      }

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure yo want to delete this record?\n This cannot be undone!",
        accept: () => {
          this.deletePartnerUser({ id: id, zone_id: this.$route.query.zone_id })
            .then((data) => {
              this.$vs.notify({
                color: "success",
                title: "Success",
                text: "Deleted successfully",
              });
              this.getItems();
            })
            .catch((error) => {
              this.$vs.notify({
                color: "danger",
                title: "Error",
                text: "Something went wrong",
              });
            });
        },
      });
    },
    verfiltro() {
      switch (this.code_type) {
        case "QR":
          this.user = {
            ...this.user,
            qrType: "QR",
          };
          this.displayInputCode = false;
          break;
        case "BARCODE_128":
          this.user = {
            ...this.user,
            qrType: "CODE128",
          };
          this.displayInputCode = true;
          break;
        case "BARCODE_39":
          this.user = {
            ...this.user,
            qrType: "CODE39",
          };
          this.displayInputCode = true;
          break;
        default:
          this.user = {
            ...this.user,
            qrType: "QR",
          };
          this.displayInputCode = false;
      }
    },
    downloadTemplate() {
      this.$vs.loading({ type: "point" });

      this.batchUploadTemplate()
        .then((dataFile) => {
          FileDownload(dataFile, "users-template.csv");
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "danger",
            title: `Error`,
            text: "Could not download users template file",
          });
        });
    },
  },
};
</script>
<style scoped>
.custom-field-container {
  min-height: 79px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.custom-field-container .vs-input--danger-text {
  font-size: 12px;
  color: red;
}
</style>
